export enum POPUP_FORM {
	SIGN_UP,
	LOGIN,
	// PASSWORD_CONFIRM,
	// PASSWORD_FORGOT,
	// PASSWORD_NEW,
}
